import type {PublicMethodUtils} from '@wix/document-services-types'
import type {AccountPublicAPI} from '@wix/document-services-public-types'
import {account} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<AccountPublicAPI> {
    return {
        methods: {
            account: {
                hasSites: publicMethodUtils.defineGetter(account.hasSites),
                isCoBranded: publicMethodUtils.defineGetter(account.isCoBranded),
                canUserUpgrade: publicMethodUtils.defineGetter(account.canUserUpgrade),
                getCoBrandedType: publicMethodUtils.defineGetter(account.getCoBrandedType)
            }
        }
    }
}
